import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, BadgeCheck, CheckCircle2, Eye, QrCode } from 'lucide-react';
import { Button } from '../../Button';
import { VerifyStepper } from '../VerifyStepper';
import { getDriver } from '../../../data/drivers';
import type { MobileNav } from '../../../types/mobile';
export function SuccessScreen({
  nav
}: {
  nav: MobileNav;
}) {
  const d = getDriver(nav.driverId) ?? getDriver('d1');
  const [marked, setMarked] = useState(false);
  if (!d) return null;
  return <div className="flex h-full flex-col bg-slate-50" data-id="element-1210" data-mp="1bw67d8nhfrhe">
      <div className="bg-bdgreen-600 px-5 pb-8 pt-8 text-center text-white" data-id="element-1211" data-mp="16y4lkfyo9e28">
        <motion.div initial={{
        scale: 0.7,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-white" data-id="element-1212" data-mp="11zl00gnzq4ae">
          <CheckCircle2 className="h-12 w-12 text-bdgreen-600" data-id="element-1213" data-mp="31al167dcy4jr" />
        </motion.div>
        <h1 className="mt-3 font-heading text-2xl font-bold" data-id="element-1214" data-mp="2we458qzx2lw4">✓ যাচাই সফল</h1>
        <p className="text-xs text-bdgreen-100" data-id="element-1215" data-mp="23xj0exott974">গাড়ি ও চালক উভয়ই বৈধ — যাত্রা অব্যাহত রাখার অনুমতি দিন</p>
      </div>
      <VerifyStepper current={4} data-id="element-1216" data-mp="28z8fcof6670h" />
      <div className="no-scrollbar flex-1 overflow-y-auto p-4" data-id="element-1217" data-mp="1u0eemyyw7fqu">
        <dl className="rounded-xl border border-border bg-white px-4 py-1 text-[13px]" data-id="element-1218" data-mp="1u1xy0yfui6wu">
          {[['সিএনজি', 'ঢাকা-থ-১১-১২৩৪'], ['চালক', d.name], ['লাইসেন্স', d.license], ['যাচাইয়ের সময়', '১২ মার্চ ২০২৬, সকাল ১০:২৪'], ['যাচাইকারী', 'সার্জেন্ট মোঃ কামরুল হাসান'], ['লোকেশন', 'মিরপুর-১০ গোলচত্বর']].map(([k, v]) => <div key={k} className="flex justify-between gap-3 border-b border-slate-100 py-2.5 last:border-0" data-id="element-1219" data-mp="2cyz30j9eg70s">
              <dt className="text-slate-500" data-id="element-1220" data-mp="2hw92krqi5z2c">{k}:</dt>
              <dd className="text-right font-semibold text-navy-900" data-id="element-1221" data-mp="35mv6q7xdyz72">{v}</dd>
            </div>)}
        </dl>
        {marked && <div className="mt-3 flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs font-semibold text-emerald-700" data-id="element-1222" data-mp="3agppn9563a53">
            <BadgeCheck className="h-4 w-4" data-id="element-1223" data-mp="3fba6dluyxnli" /> যাচাইকৃত হিসেবে চিহ্নিত ও কেন্দ্রীয় সার্ভারে সংরক্ষিত (রেফ: VR-20260312-1024)
          </div>}
      </div>
      <div className="grid gap-2 border-t border-border bg-white p-3" data-id="element-1224" data-mp="36au8qt0wpaok">
        <Button onClick={() => {
        setMarked(true);
        nav.showToast('যাচাইকৃত হিসেবে চিহ্নিত হয়েছে');
      }} disabled={marked} className="h-11 w-full bg-bdgreen-600 hover:bg-bdgreen-700" data-id="element-1225" data-mp="36akhl244kxha">
          <BadgeCheck className="h-4 w-4" data-id="element-1226" data-mp="2rlfup7mdy52u" /> {marked ? 'যাচাইকৃত হিসেবে চিহ্নিত' : 'যাচাইকৃত হিসেবে চিহ্নিত করুন'}
        </Button>
        <div className="grid grid-cols-2 gap-2" data-id="element-1227" data-mp="2nlxdomxoqe5a">
          <Button variant="outline" onClick={() => nav.go('result')} className="h-10" data-id="element-1228" data-mp="2ikzxgfw8ju6f"><Eye className="h-4 w-4" data-id="element-1229" data-mp="2inc9kcfbbabk" />বিস্তারিত দেখুন</Button>
          <Button variant="outline" onClick={() => {
          nav.setReportContext('valid');
          nav.go('report');
        }} className="h-10 text-red-700 hover:text-red-700" data-id="element-1230" data-mp="2dn7xcylft1r5"><AlertTriangle className="h-4 w-4" data-id="element-1231" data-mp="t6i58ln1scik" />অনিয়ম রিপোর্ট</Button>
        </div>
        <Button variant="secondary" onClick={() => {
        nav.setScenario('valid');
        nav.reset('scanner');
      }} className="h-10 w-full" data-id="element-1232" data-mp="y1e1jxzbhm1h"><QrCode className="h-4 w-4" data-id="element-1233" data-mp="130h7dkn4fwai" />নতুন QR স্ক্যান করুন</Button>
      </div>
    </div>;
}